import { render } from "./hamburger-button.vue?vue&type=template&id=1f08505d"
import script from "./hamburger-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./hamburger-button.vue?vue&type=script&setup=true&lang=ts"

import "./hamburger-button.vue?vue&type=style&index=0&id=1f08505d&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1f08505d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f08505d', script)) {
    api.reload('1f08505d', script)
  }
  
  module.hot.accept("./hamburger-button.vue?vue&type=template&id=1f08505d", () => {
    api.rerender('1f08505d', render)
  })

}

script.__file = "resources/ts/components/elements/hamburger-button.vue"

export default script